import React, { useRef, useState, useEffect, useLayoutEffect, useCallback } from 'react';
import classes from './Shoutbox.module.css';

import firebase from 'firebase/compat/app';
import { auth, firestore } from '../../firebase/index';

import axios from '../../axiosdata';
import Button from '../../UI/Buttons/GoogleButton';

import { useAuthState } from 'react-firebase-hooks/auth';
import { useCollectionData } from 'react-firebase-hooks/firestore';


function Shoutbox(props) {
  const [user] = useAuthState(auth);

  return (
    <div>
        { props.showShoutbox ?  
        <div>
          { user ? 
          <ChatRoom isAuthenticated={props.isAuthenticated} /> 
          : <div className={classes.dummyChat}>    
              <div className={classes.dummyChatTop}/>
              <div className={classes.dummyMessage}>
                  <SignIn />
              </div>
              <div className={classes.dummyChatBottom}/>
            </div>
          } 
        </div> 
          : <div className={classes.dummyChat}>    
              <div className={classes.dummyChatTop}/>
                <div className={classes.dummyMessage}>
                  <h2>Shoutbox suljettu!</h2>
                </div>
              <div className={classes.dummyChatBottom}/>
            </div>
          }
    </div>
  );
}

function SignIn() {

  const [showRules, setShowRules] = useState(false);

  const changeShowRulesState = () => {
    showRules ? setShowRules(false) : setShowRules(true);
  }

  const signInWithGoogle = () => {
    const provider = new firebase.auth.GoogleAuthProvider();
    auth.signInWithPopup(provider);
  }

  return (
    <div className={classes.signInContainer}>
      <div className={classes.infoText}>Kirjaudu sisään Google-tililläsi. Kirjautumalla hyväksyt kaikki säännöt ja käyttöehdot.</div>
      <div className={classes.signInButton} >
        <Button click={signInWithGoogle}>Sign in with Google</Button>
      </div>

      <div className={classes.rules}>
        <h3>Säännöt ja käyttöehdot</h3>
          {showRules ? 
          <div>
            <ul>
              <li>Kirjoita jotain mukavaa, älä häiriköi tai spämmi.</li>
              <li>Jos et kekski mitään järkevää sanottavaa keskity kuuntelemaan radiosta tulevia loistavia ohjelmia.</li>
              <li>Mitään loukkaavaa sisältöä ei sallita.</li>
              <li>Sivuston ylläpidolla on mahdollisuus nähdä sähköpostiosoitteesi kirjauduttuasi Shoutboxiin Google-tililläsi.</li>
              <li>Sivuston ylläpidolla on oikeus estää shoutboxin käyttäjä, mikäli kyseisen henkilön katsotaan rikkoneen shoutboxin sääntöjä.</li>
            </ul>
          </div>
          : null}
          {showRules ? <div className={classes.showRules} onClick={changeShowRulesState}>Piilota</div> : <div className={classes.showRules} onClick={changeShowRulesState}>Näytä...</div>}
      </div>
    </div>
  )

}

function SignOut() {
  return auth.currentUser && (
    <Button className="sign-out" click={() => auth.signOut()}>Sign out</Button>
  )
}


function ChatRoom(props) {

  const [showMessagesCount, setShowMessagesCount] = useState(15);
  const dummy = useRef();
  const messageBodyRef = useRef();
  const scrollRestorationRef = useRef(null);
  const messagesRef = firestore.collection('messages');
  const query = messagesRef.orderBy('createdAt').limitToLast(showMessagesCount);

  const [messages] = useCollectionData(query, { idField: 'id' });

  const [formValue, setFormValue] = useState('');
  const [formValueUser, setFormValueUser] = useState('');
  const [adminUser, setAdminUser] = useState(false);
  const [warningMessage, setWarningMessage] = useState('')
  const [showWarningMessage, setShowWarningMessage] = useState(false)
  const [shoutboxState, setShoutboxState] = useState(false);
  const [userAuthState, setUserAuthState] = useState(false);
  const [userAuth] = useAuthState(auth);

  const [adminUids, setAdminUids] = useState({});
  const [blockedUsers, setBlockedUsers] = useState({});

  const checkIfStudioUser = useCallback(() => {
    if (!auth.currentUser) return;
    const { uid } = auth.currentUser;
    axios.get('/admin_users.json')
      .then(res => {
        if (res.data) {
          setAdminUids(res.data);
          if (res.data[uid]) {
            setFormValueUser(res.data[uid].displayName || 'Admin');
            setAdminUser(true);
          }
        }
      })
      .catch(err => console.error('Error fetching admin users:', err));
  }, []);

  const fetchBlockedUsers = useCallback(() => {
    axios.get('/blocked_users.json')
      .then(res => { if (res.data) setBlockedUsers(res.data); })
      .catch(err => console.error('Error fetching blocked users:', err));
  }, []);

  const checkIfShoutboxOpen = useCallback(() => {
    setUserAuthState(!!userAuth);
    axios.get('/shoutbox.json')
      .then(res => setShoutboxState(res.data.show.show))
      .catch(err => console.error('Failed to fetch shoutbox state:', err));
  }, [userAuth]);

  const scrollDown = useCallback(() => {
    if (messageBodyRef.current) {
      messageBodyRef.current.scrollTop = messageBodyRef.current.scrollHeight;
    }
  }, []);

  useEffect(() => {
    checkIfStudioUser();
    checkIfShoutboxOpen();
    fetchBlockedUsers();
  }, [checkIfStudioUser, checkIfShoutboxOpen, fetchBlockedUsers]);

  useLayoutEffect(() => {
    if (!messages) return;
    if (scrollRestorationRef.current !== null) {
      const { scrollTop, scrollHeight } = scrollRestorationRef.current;
      const newScrollHeight = messageBodyRef.current.scrollHeight;
      if (newScrollHeight > scrollHeight) {
        messageBodyRef.current.scrollTop = scrollTop + (newScrollHeight - scrollHeight);
        scrollRestorationRef.current = null;
      }
    } else {
      scrollDown();
    }
  }, [messages, scrollDown]);

  const checkMessageContent = () => {
    let str = formValue;
    let user = formValueUser;
    let valid = true;

    function hasTooManyWhiteSpaces(s){
      return s.trim().length >= 2;
    }

    if (!hasTooManyWhiteSpaces(user)){
      valid = false;
      setWarningMessage('Anna kunnon nimimerkki! (Vähintään 2 merkkiä ja max 40)')
      setShowWarningMessage(true)
    }

    const currentUid = auth.currentUser?.uid;
    const ownEntry = adminUids[currentUid];
    const ownNames = ownEntry
      ? (ownEntry.displayNames
          ? ownEntry.displayNames.map(n => n.toLowerCase().trim())
          : [(ownEntry.displayName || '').toLowerCase().trim()])
      : [];
    const allProtectedNames = Object.values(adminUids).flatMap(a =>
      a.displayNames ? a.displayNames.map(n => n.toLowerCase().trim()) : [(a.displayName || '').toLowerCase().trim()]
    );
    if (allProtectedNames.includes(user.toLowerCase().trim()) && !ownNames.includes(user.toLowerCase().trim())) {
      valid = false;
      setWarningMessage('Tämä nimimerkki on varattu!');
      setShowWarningMessage(true);
    }

    for(let i = 0, count = 0, mcount = 0; i < str.length; i++){
        if(str[i] === 'M' || str[i] === 'm' ){
          mcount++;
        } 
        if(mcount >= 10){
          setWarningMessage('Älä spämmi!')
          setShowWarningMessage(true)
          valid = false;
        }
       if(count > 200){
          setWarningMessage('Max 200 merkkiä!')
          setShowWarningMessage(true)
          valid = false;
       }else{
          count++;
       }
    }
    return valid;
  }

  const deleteMessage = (id) => {
    messagesRef.doc(id).delete()
      .catch(err => console.error('Error deleting message:', err));
  };

  const blockUser = (uid, username) => {
    if (!window.confirm(`Estetäänkö käyttäjä "${username}"?`)) return;
    const data = { username, blockedAt: new Date().toISOString(), blockedBy: auth.currentUser?.uid };
    axios.put(`/blocked_users/${uid}.json`, data)
      .then(() => setBlockedUsers(prev => ({ ...prev, [uid]: data })))
      .catch(err => console.error('Error blocking user:', err));
  };

  const sendMessage = async (e) => {
    e.preventDefault();
    if(shoutboxState && checkMessageContent()){
      const { uid, photoURL } = auth.currentUser;
      if (blockedUsers[uid]) {
        setWarningMessage('Sinut on estetty Shoutboxista.');
        setShowWarningMessage(true);
        return;
      }
      await messagesRef.add({
          user: formValueUser,
          text: formValue,
          time: new Date().toLocaleString(),
          color: getRandomColor(),
          createdAt: firebase.firestore.FieldValue.serverTimestamp(),
          uid,
          photoURL,
          auth: userAuthState,
          isAdmin: adminUser  // Include admin status in message
      })

      setFormValue('');
      scrollDown();
      setShowWarningMessage(false)
      await checkIfShoutboxOpen();
    } else{
      if(shoutboxState === false){
        setWarningMessage('Shoutbox suljettu')
      }
    }
  }

  const showMoreMessages = (event) => {
    event.preventDefault();
    if (messageBodyRef.current) {
      const el = messageBodyRef.current;
      scrollRestorationRef.current = { scrollTop: el.scrollTop, scrollHeight: el.scrollHeight };
    }
    setShowMessagesCount(showMessagesCount + 15);
  }

  function getRandomColor() {
    const letters = '0123456789ABCDEF';
    let randColor = '#';
    for (let i = 0; i < 6; i++) {
        randColor += letters[Math.floor(Math.random() * 16)];
    }
    return {
        color: randColor
    };
  }
  
  return (
    <div className={classes.shoutbox}>
        <div className={classes.signOut}>
            <SignOut/>
        </div>
     
        <div className={classes.messages_section} ref={messageBodyRef}>
            {props.isAuthenticated || adminUser ?
              <div className={classes.showMoreMessages} id="moremessages">
                <div className={classes.tag} onClick={showMoreMessages}>
                  Näytä lisää
                </div>
              </div>
            : null}
            {messages && messages.map(msg => (
              <ChatMessage
                key={msg.id}
                message={msg}
                isAuthenticated={props.isAuthenticated}
                adminUids={adminUids}
                onDelete={deleteMessage}
                onBlock={blockUser}
              />
            ))}
            <span ref={dummy}></span>
        </div>
        <div className={classes.form_section_background}>
            <form onSubmit={sendMessage} className={classes.form_section}>
                <input value={formValueUser} onChange={(e) => setFormValueUser(e.target.value)} placeholder="Nimimerkki (max 40 merkkiä)" className={classes.username_input} />
                <input value={formValue} onChange={(e) => setFormValue(e.target.value)} placeholder="Say something nice (max 200 merkkiä)" className={classes.text_input}/>
                {showWarningMessage ? <div className={classes.warningMessage}>{warningMessage}</div> : null}
                  { formValue.length > 0 ? 
                    <div className={classes.charactersLeft}>
                      Merkkejä jäljellä {200 - formValue.trim().length}
                      {formValue.trim().length > 150 ? ' - Riittää jo! Ei tänne mitää esseetä tarvi kirjottaa!' : null}
                    </div>
                    :
                    null
                  }
                <button type="submit" disabled={
                  !formValue 
                  || !formValueUser 
                  || formValue.length > 200
                  || formValueUser.length > 40 
                  || formValue.length < 2 
                  || formValue === '  '
                  || formValueUser === '  '
                  } className={classes.shout_button}>Shout!</button>

            </form>
        </div>
    </div>
  )
}



function ChatMessage(props) {

    const { text, user, time, color, uid } = props.message;
    const isAdmin = props.adminUids && props.adminUids[uid];

    const breakString = (str, limit) => {
      let brokenString = '';
      for(let i = 0, count = 0, mcount = 0; i < str.length; i++){
          if(str[i] === 'M' || str[i] === 'm' ){
            mcount++;
          }
          if(mcount >= 18){
            mcount = 0;
            count = 0;
            brokenString += '\n';
          }
          if(str[i] === ' ' && count < limit){
             count = 0;
          }
          if(count >= limit){
            count = 0;
            brokenString += str[i] + "-\n";
          }
          else{
            count++;
            brokenString += str[i];
         }
      }
      return brokenString;
   }

    const adminActions = props.isAuthenticated ? (
      <div className={classes.messageActions}>
        <button className={classes.actionButton} onClick={() => props.onDelete(props.message.id)} title="Poista viesti">🗑</button>
        {!isAdmin && <button className={classes.actionButton} onClick={() => props.onBlock(uid, user)} title="Estä käyttäjä">🚫</button>}
      </div>
    ) : null;

    if(isAdmin){
      return (
        <div className={classes.message}>
          <div className={classes.usernameAdmin}>{user}:</div>
          <div className={classes.text}>{text}</div>
          <div className={classes.id}>{props.isAuthenticated ? '('+uid+')': null}</div>
          <div className={classes.time}>{time}</div>
          {adminActions}
        </div>
      );
    }

    return (
      <div className={classes.message}>
        <div className={classes.username} style={color}>{user}:</div>
        <div className={classes.text}>{breakString(text, 45)}</div>
        <div className={classes.id}>{props.isAuthenticated ? '('+uid+')': null}</div>
        <div className={classes.time}>{time}</div>
        {adminActions}
      </div>
    );
}

  export default Shoutbox;